import type { LambAnalytics } from '../core/sdk';

export interface EcommerceItem {
  item_id: string;
  item_name: string;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_variant?: string;
  price?: number;
  quantity?: number;
  coupon?: string;
  discount?: number;
  index?: number;
  item_list_id?: string;
  item_list_name?: string;
}

export interface ViewItemListParams {
  item_list_id?: string;
  item_list_name?: string;
  items: EcommerceItem[];
}

export interface SelectItemParams {
  item_list_id?: string;
  item_list_name?: string;
  items: EcommerceItem[];
}

export interface ViewItemParams {
  currency?: string;
  value?: number;
  items: EcommerceItem[];
}

export interface AddToWishlistParams {
  currency?: string;
  value?: number;
  items: EcommerceItem[];
}

function validateItems(items: EcommerceItem[]): EcommerceItem[] {
  return items.filter((item) => {
    if (!item.item_id || !item.item_name) {
      if (typeof console !== 'undefined') {
        console.warn('[LambAnalytics] Ecommerce item missing item_id or item_name, skipping:', item);
      }
      return false;
    }
    return true;
  });
}

export class ProductTracker {
  private sdk: LambAnalytics;

  constructor(sdk: LambAnalytics) {
    this.sdk = sdk;
  }

  viewItemList(params: ViewItemListParams): void {
    const validItems = validateItems(params.items);
    if (validItems.length === 0) return;

    this.sdk.track('view_item_list', {
      item_list_id: params.item_list_id,
      item_list_name: params.item_list_name,
      items: validItems,
    });
  }

  selectItem(params: SelectItemParams): void {
    const validItems = validateItems(params.items);
    if (validItems.length === 0) return;

    this.sdk.track('select_item', {
      item_list_id: params.item_list_id,
      item_list_name: params.item_list_name,
      items: validItems,
    });
  }

  viewItem(params: ViewItemParams): void {
    const validItems = validateItems(params.items);
    if (validItems.length === 0) return;

    this.sdk.track('view_item', {
      currency: params.currency,
      value: params.value,
      items: validItems,
    });
  }

  addToWishlist(params: AddToWishlistParams): void {
    const validItems = validateItems(params.items);
    if (validItems.length === 0) return;

    this.sdk.track('add_to_wishlist', {
      currency: params.currency,
      value: params.value,
      items: validItems,
    });
  }
}
